// Copyright (c) 2023 Deere & Company

import DuplicatePinPlateView, { getDefaultState } from '../state/duplicate-pin-plate-view';
import actions from '../../../sharedmodules/actions-list';

const updateDuplicatePinPlateChanges = (state, action) => DuplicatePinPlateView.update(state, {
    $set: action.data,
});

const resetDuplicatePlate = (state, action) => DuplicatePinPlateView.update(state, {
    $set: action.data,
});

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_DUPLICATE_PIN_PLATE]: resetDuplicatePlate,
        [actions.UPDATE_TCSM_DUPLICATE_PIN_PLATE]: updateDuplicatePinPlateChanges,
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};
